import { Row, Col } from 'antd'
import SummariesChart from './SummariesChart/SummariesChart'
import SummariesTable from './SummariesTable/SummariesTable'

export const COLORS = [
  '#63daab',
  '#f1526c',
  '#d0f4e5',
  '#cfdffd',
  '#f8d2ce',
  '#d6eff9',
  '#e96c5c',
  '#fcecbd',
  '#74cbed',
  '#f6c02d',
  '#5b8ff9',
  '#657798',
  '#d0d6e0'
]

const ReturnSummaries = props => {
  const {
    data,
    topThree,
    isOrderSearch,
    onSortChange,
    sortType,
    onListingCountClick
  } = props
  return (
    <Row
      type='flex'
      justify='center'
      align='middle'
    >
      <Col span={12}>
        <SummariesChart
          data={data}
          topThree={topThree}
          sortType={sortType}
        />
      </Col>
      <Col span={12}>
        <SummariesTable
          data={data}
          isOrderSearch={isOrderSearch}
          onSortChange={onSortChange}
          sortType={sortType}
          onListingCountClick={onListingCountClick}
        />
      </Col>
    </Row>
  )
}

export default ReturnSummaries
